export function offeringAnalysisContext(type:string,name:string,description:string){
 return type==='software'||type==='service'?{type,name,description}:undefined;
}
/** Only untouched blanks accept suggestions; clearing a field is also an edit. */
export function fillOfferingSuggestion<T extends string|string[]>(current:T,initial:T,suggestion:T,revision:number,initialRevision:number):T{
 const blank=(value:T)=>typeof value==='string'?!value.trim():value.length===0;
 return revision===initialRevision&&blank(initial)&&blank(current)?suggestion:current;
}
